import type { ComponentProps, FC } from "react";

import { StatusBadge } from "@/components/ui/status-badge";

import type {
  FirmSkillRunStatus,
  FirmSkillStatus
} from "@/features/firmKnowledge/types";

type Tone = NonNullable<ComponentProps<typeof StatusBadge>["tone"]>;

const SKILL_STATUS: Record<FirmSkillStatus, { label: string; tone: Tone }> = {
  draft: { label: "Draft", tone: "neutral" },
  active: { label: "Enabled", tone: "success" },
  archived: { label: "Archived", tone: "neutral" }
};

export const SkillStatusBadge: FC<{ status: FirmSkillStatus }> = ({
  status
}) => {
  const meta = SKILL_STATUS[status] ?? SKILL_STATUS.draft;
  return (
    <StatusBadge
      tone={meta.tone}
      dot={status === "active"}
      data-testid="skill-status"
      data-status={status}
    >
      {meta.label}
    </StatusBadge>
  );
};

const RUN_STATUS: Record<FirmSkillRunStatus, { label: string; tone: Tone }> = {
  running: { label: "Running", tone: "info" },
  needs_input: { label: "Needs Your Answer", tone: "warn" },
  needs_approval: { label: "Needs Approval", tone: "warn" },
  completed: { label: "Completed", tone: "success" },
  stopped: { label: "Stopped", tone: "neutral" },
  failed: { label: "Failed", tone: "danger" }
};

export const SkillRunStatusBadge: FC<{ status: FirmSkillRunStatus }> = ({
  status
}) => {
  const meta = RUN_STATUS[status] ?? RUN_STATUS.running;
  return (
    <StatusBadge tone={meta.tone} data-testid="run-status" data-status={status}>
      {meta.label}
    </StatusBadge>
  );
};
